import '../styles/main/index.css';
import { close, menu, logo } from '../images/images';
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Authentication from "../api/Authentication/Authentication";

const Menu = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(Authentication.getCurrentUser() || null);
  const [toggleMenu, setToggleMenu] = useState(false);
  const sidebarRef = useRef(null);

  // Poll for auth changes
  useEffect(() => {
    const interval = setInterval(() => {
      const user = Authentication.getCurrentUser();
      setCurrentUser(user || null);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Detect outside clicks to close
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toggleMenu && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setToggleMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [toggleMenu]);

  const navLinks = [
    { name: 'Home', link: '/', user: undefined, admin: false, enabled: false, onClick: undefined },
    { name: 'Files', link: '/browser', user: true, admin: false, enabled: true, onClick: undefined },
    { name: 'Account', link: '/account/', user: true, admin: false, enabled: true, onClick: undefined },
    { name: 'Admin', link: '/admin', user: true, admin: true, enabled: true, onClick: undefined },
    { name: 'Logout', link: '/', user: true, admin: false, enabled: false, onClick: Authentication.logout },
    { name: 'Login', link: '/login', user: false, admin: false, enabled: false, onClick: undefined },
  ];

  const shouldShowNavLink = (nav) => {
    if (nav.enabled) {
      if (nav.user && !nav.admin && currentUser?.enabled) return true;
      if (nav.admin && currentUser?.isAdmin && currentUser.enabled) return true;
    } else {
      if (nav.user === undefined) return true;
      if (!nav.user && !currentUser) return true;
      if (nav.user && !nav.admin && currentUser) return true;
      if (nav.admin && currentUser?.isAdmin) return true;
    }
    return false;
  };

  const handleLinkClick = (nav) => {
    if (nav.onClick) nav.onClick();
    setToggleMenu(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    setToggleMenu(false);
  };

  return (
    <>
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`pl-4 md:pl-0 fixed top-0 left-0 h-full z-40 bg-gray-900 shadow-lg transform transition-transform duration-300 w-64 ${
          toggleMenu ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full p-6">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3 cursor-pointer" onClick={handleLogoClick}>
              <img src={logo} alt="Logo" className="w-10 h-10" />
              <h1 className="text-white text-xl font-bold">Imperium</h1>
            </div>
            <img
              src={close}
              alt="Close"
              className="w-8 h-8 cursor-pointer hover:scale-110 transition-transform"
              onClick={() => setToggleMenu(false)}
            />
          </div>

          {/* Navigation */}
          <ul className="mt-8 space-y-4 text-white">
            {navLinks.map((nav, index) =>
              shouldShowNavLink(nav) && (
                <li key={index}>
                  <a
                    href={
                      nav.link === '/account/' && currentUser
                        ? `${nav.link}${currentUser._id}`
                        : nav.link
                    }
                    onClick={() => handleLinkClick(nav)}
                    className="block hover:text-red-500 transition"
                  >
                    {nav.name}
                  </a>
                </li>
              )
            )}
          </ul>

          <div className="mt-auto text-center text-gray-500 text-xs pt-8">
            &copy; {new Date().getFullYear()} ImperiumCloud
          </div>
        </div>
      </div>

      {/* Toggle Button Bar (shown when menu is closed) */}
      {!toggleMenu && (
        <div className="fixed left-0 top-1/2 -translate-y-1/2 z-40 group">
          <button
            onClick={() => setToggleMenu(true)}
            className="bg-gray-800 hover:bg-gray-700 text-white rounded-r-lg px-2 py-2 shadow-md transition"
            aria-label="Open menu"
          >
            <img src={menu} alt="Menu" className="w-5 h-5" />
          </button>
        </div>
      )}
    </>
  );
};

export default Menu;